export { default as NEllipsis, ellipsisProps } from './src/Ellipsis';
